module.exports = __webpack_public_path__ + "img/avatar-profil.2098f196.jpg";